import { defineStore } from 'pinia';
import { normalizeRewardsData, storeLoyaltyStatusForLegacy } from '~/composables/useLoyalty';
import { useLoyaltyPointsFetch } from '~/composables/dumb/useLoyaltyPointsFetch';
import { fireLinkTag } from '#shared/features/analytics/tagManager';
import { useNavKillswitch } from './navKillswitch';
import { useNavUser } from './navUser';

export const useNavLoyalty = defineStore('navLoyalty', {
  state: () => ({
    rewardsData: null,
    sourceRewardsData: null, // raw data from loyalty xapi
    initialized: false,
  }),
  getters: {
    getRewardsData(state) {
      return state.rewardsData || {};
    },
    getSourceRewardsData(state) {
      return state.sourceRewardsData;
    },
  },
  actions: {
    setRewardsData({ sourceRewardsData, normalizedRewardsData }) {
      this.sourceRewardsData = sourceRewardsData;
      this.rewardsData = normalizedRewardsData;
    },
    setInitialized() {
      this.initialized = true;
    },

    async fetchRewardsData() {
      if (this.rewardsData) {
        this.setInitialized();
        return;
      }

      const envProps = useEnvProps();
      const navUser = useNavUser();
      const { killswitches } = useNavKillswitch();

      const { isMcom, hostlink } = envProps;
      const { isSignedIn, guid, uid } = navUser.data;

      try {
        const result = await useLoyaltyPointsFetch({
          isSignedIn,
          uid,
          guid,
          isMcom,
          killswitches,
          hostlink,
        });

        if (result && !result.errors) {
          const normalizedRewardsData = normalizeRewardsData(result, isMcom);

          this.setRewardsData({
            sourceRewardsData: result,
            normalizedRewardsData,
          });
          storeLoyaltyStatusForLegacy(result, isMcom);

          // Fire loyalty analytics event only once per session
          if (!sessionStorage.navLoyaltyEventFired) {
            const payload = {
              event_name: 'loyalty call',
              link_name: 'loyalty call',
              CustomerFirstName: navUser.data.username,
              customer_loyalty_id: isMcom ? result.encryptedLoyaltyId : result.loyalty.id,
              customer_loyalty_tier: normalizedRewardsData.tierName,
              loyalty_balance: normalizedRewardsData.points.current,
              rewards_balance: normalizedRewardsData.balance,
            };

            fireLinkTag(payload);
            sessionStorage.navLoyaltyEventFired = true; // Prevent additional fires
          }
        } else {
          storeLoyaltyStatusForLegacy({}, isMcom);
        }
      } catch (e) {
        console.error('loyaltyPointsFetch error', e);
        storeLoyaltyStatusForLegacy({}, isMcom);
      } finally {
        this.setInitialized();
      }
    },
  },
});
